export default __webpack_public_path__ + "static/media/permission.51138229.svg";